<template>
    <div class="text-xs font-semibold whitespace-nowrap mt-3">
        <span
            v-if="items.includes('CUSTOMER')"
            class="py-1 px-2 rounded last:mr-0 mr-1"
            :class="styleClass('CUSTOMER')">
            {{ labelDefault.CUSTOMER }}
        </span>

        <span
            v-if="items.includes('PARTNER')"
            class="py-1 px-2 rounded last:mr-0 mr-1"
            :class="styleClass('PARTNER')">
            {{ labelDefault.PARTNER }}
        </span>

        <span
            v-if="items.includes('VENDOR')"
            class="py-1 px-2 rounded last:mr-0 mr-1"
            :class="styleClass('VENDOR')">
            {{ labelDefault.VENDOR }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  types: Array
})
const { types } = toRefs(props)
const whiteList = ['CUSTOMER', 'PARTNER', 'VENDOR']
const labelDefault = {
  CUSTOMER: $t('labels.customer'),
  PARTNER: $t('labels.partner'),
  VENDOR: $t('labels.vendor')
}
const styleClass = (value: String) => {
  switch (value) {
  case 'CUSTOMER':
    return 'text-pink-600 bg-pink-200'
  case 'PARTNER':
    return 'text-blue-600 bg-blue-200'
  case 'VENDOR':
    return 'text-yellow-600 bg-yellow-200'
  }
}

const items = computed(() => {
  if (!types?.value || !Array.isArray(types.value)) {
    return []
  }

  const items = whiteList.filter((item) => types?.value?.includes(item))

  return items
})
</script>
